import React from 'react';
import styled from 'styled-components';
import '@fortawesome/fontawesome-free/css/all.css'


const Styles = styled.div`
input[type="file"] {
    display: none;
}
.file-upload {
            border: 4px solid #007bff;
    display: inline-block;
    padding: 12px 28px;
    cursor: pointer;
    color: #f2f5f9;
    font-size: 20px;
    margin-top: 30px;
    background-color: #007bff;
}

`;
export class Uploadbutton extends React.Component {
  constructor (props) {
        super(props);
  }
  fileName;
  onFileChange(event) {
    this.fileName = event.target.value.toLowerCase();
    this.props.onChange(this.fileName);
  }
  // This syntax ensures `this` is bound within handleClick.
  // Warning: this is *experimental* syntax.
  
  render() {
    return (
      <Styles>
        <form method="post" id="uploadForm" onChange={this.onFileChange.bind(this)}>
            <div className="field">
              <label className="file-upload">
                    <input type="file" name="file" id="inFile"/><i className="fas fa-cloud-upload-alt"></i> {this.props.buttonName} File
              </label>
            </div>
        </form>
        </Styles>
    );
  }
}